import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
export const VirtualClassroom = () => {
  const navigate = useNavigate();
  // Immediately redirect back to dashboard
  useEffect(() => {
    navigate('/teacher-dashboard');
  }, [navigate]);
  // Return null to render nothing
  return null;
};